import React from 'react'
import Switcher from '../../components/switcher'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'react-feather';
import { LiaThumbsUpSolid } from 'react-icons/lia';

export default function Thankyou() {
    return (
        <>
            <section className="relative h-screen flex items-center justify-center text-center bg-gray-50 dark:bg-slate-800">
                <div className="container relative">
                    <div className="grid grid-cols-1">
                        <div className="title-heading text-center my-auto">
                            <div className="size-24 bg-tone/5 text-tone rounded-full text-5xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 mx-auto">
                                <LiaThumbsUpSolid/>
                            </div>
                            <h1 className="mt-6 mb-8 md:text-5xl text-3xl font-bold">Thank You</h1>
                            <p className="text-slate-400 max-w-xl mx-auto">We are a huge marketplace dedicated to connecting great artists of all Solar Exchange with their fans and unique token collectors!</p>

                            <div className="mt-6">
                                <Link to="/index" className="btn bg-tone/5 hover:bg-tone border-tone/10 hover:border-tone text-tone hover:text-white rounded-full">Back to Home</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="fixed bottom-3 end-3">
                <Link to="/" className="back-button btn btn-icon bg-tone hover:bg-hover-tone border-tone hover:border-hover-tone text-white rounded-full"><ArrowLeft className="size-4"></ArrowLeft></Link>
            </div>
            <Switcher />
        </>
    )
}
